function OverlayLoader (typeSize, colorStyle, overlay) {
  if (overlay) {
    return `<div class="loader-wrap" style="position:fixed; width:100%; height:100%; top:0; left:0; z-index:99999; background:rgba(0,0,0,0.5);"><div class="loader__inner loader--${colorStyle} loader__inner--${typeSize}"><div class="water-splash"><div><span></span><span></span><span></span></div></div></div></div>`
  } else {
    return `<div class="loader__inner loader--${colorStyle} loader__inner--${typeSize}"><div class="water-splash"><div><span></span><span></span><span></span></div></div></div></div>`
  }
}

module.exports = OverlayLoader



// WEBPACK FOOTER //
// ./src/modules/overlayLoader.js